<c-container class="mt-5">
  <h2>Error Debugging</h2>
  <p class="text-muted">View failed audit events across all sources (Admin, Player, System)</p>
  @if (uiState == uiStateForTemplate.ShowData) {
    <app-failed-audits-table></app-failed-audits-table>
  }
</c-container>
